<div class="description-container">
    <div class="title">
        <h2>{{ speciality.name | uppercase }}</h2>
    </div>
    <div class="description">
        <div class="des" [innerHTML]="speciality.description"></div>
    </div>
    <h3 [ngStyle]="{ 'text-align': 'start', width: '90%' }">{{ speciality.specialityType?.jobTitle }}</h3>
    <div class="doctor-container">
        <div *ngFor="let doctorSpeciality of speciality.doctorSpecialityList" class="doctor">
            <div [routerLink]="'/doctor/' + doctorSpeciality.doctor?.routerLink" class="datas">
                <div>
                    <img [src]="doctorSpeciality.doctor?.image" />
                    <span [ngStyle]="{ 'font-size': '13px' }">{{ doctorSpeciality.doctor?.name | uppercase }}</span>
                </div>
                <div class="consulting-hour-container">
                    <span>RENDELÉSI IDŐ:</span>
                    <div class="consult">
                        <div *ngFor="let consultingHour of doctorSpeciality.doctor?.doctorConsultingHourList">
                            <div class="consulting">
                                <span>{{ consultingHour.day }}:</span>
                                <span *ngIf="consultingHour.startTime !== null && consultingHour.endTime !== null">
                                    {{ consultingHour.startTime }} - {{ consultingHour.endTime }}
                                </span>
                                <span *ngIf="consultingHour.startTime === null && consultingHour.endTime === null"> változó</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
